import { render } from "./ClientSearch.vue?vue&type=template&id=2a720b2e&scoped=true"
import script from "./ClientSearch.vue?vue&type=script&lang=js"
export * from "./ClientSearch.vue?vue&type=script&lang=js"

import "@/assets/style/table.css?vue&type=style&index=0&lang=css"
import "./ClientSearch.vue?vue&type=style&index=1&id=2a720b2e&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a720b2e"]])

export default __exports__